import { connect } from 'react-redux';

import {
  getOfficesShortList,
  getPublicZoneList,
} from '../../Offices/officesActions';
import { getOrganizationMembersList } from '../../Projects/projectsActions';
import {
  getItemSubTasks,
  getSubTaskEvidence,
  getTaskLocation,
  updateSubTaskApproval,
} from '../tasksActions';
// Component
import SubTaskApproval from './SubTaskApproval';

// Store props to map with current state
const mapStateToProps = state => ({
  selectedOrganization: state.organization.selectedOrganization,
  orgMembersList: state.project.orgMembersList,
  officesShortList: state.office.officesShortList,
  publicZoneList: state.office.publicZoneList,
  locationsList: state.task.locationsList,
  itemSubTasksList: state.task.itemSubTasksList,
  isLoading: state.task.isLoadingItemSubTasks,
  isLoadingSubTaskApproval: state.task.isLoadingSubTaskApproval,
  loadingTaskAssigneeId: state.project.loadingTaskAssigneeId,
  // pagination
  totalSubTasksCount: state.task.itemSubTasksListCount,
  pageSize: state.task.itemSubTasksPageSize,
});

// Actions prop to dispatch
const mapDispatchToProps = dispatch => ({
  getOrganizationMembersList: params =>
    dispatch(getOrganizationMembersList(params)),
  getItemSubTasks: params => dispatch(getItemSubTasks(params)),
  getOfficesShortList: params => dispatch(getOfficesShortList(params)),
  updateSubTaskApproval: params => dispatch(updateSubTaskApproval(params)),
  getSubTaskEvidence: params => dispatch(getSubTaskEvidence(params)),
  getTaskLocation: params => dispatch(getTaskLocation(params)),
  getPublicZoneList: params => dispatch(getPublicZoneList(params)),
});

// connect states and dispatchers with components
export default connect(mapStateToProps, mapDispatchToProps)(SubTaskApproval);
